<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10 p-lg-10">
                <label class="p-mr-2">{{ $t("local_event") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_table == true">{{
              $t("table_validate")
            }}</span>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col p-ml-3 p-mt-3">
            <div class="p-formgrid p-grid p-col">
              <div class="p-field p-col-12 p-lg-3">
                <label>{{ $t("startYear") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col">
                    <Dropdown
                      v-model="selectedStartYear"
                      :options="year"
                      optionLabel="name"
                      id="ds_selectedStartYear"
                    />
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12 p-lg-3">
                <label>{{ $t("endYear") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col">
                    <Dropdown
                      v-model="selectedEndYear"
                      :options="year"
                      optionLabel="name"
                      id="ds_selectedEndYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="p-formgrid p-grid p-col p-mt-4 p-mb-4">
              <div class="p-field p-col-12 p-lg-12">
                <label>{{ $t("disaster_type") }}</label>
                <Dropdown
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :filter="true"
                  :placeholder="$t('placeholderSelectBox')"
                  :clearFilterDropdown="dropdownClearFilerValue"
                >
                  <template #value="disasterTypeOptions">
                    <div v-if="disasterTypeOptions.value">
                      <div>{{ disasterTypeOptions.value.system_name }}</div>
                    </div>
                    <span v-else>
                      {{ disasterTypeOptions.placeholder }}
                    </span>
                  </template>
                  <template #option="disasterTypeOptions">
                    <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                  </template>
                </Dropdown>
              </div>

            <div class="p-col">
              <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                <div class="p-field p-col p-mt-2">
                   <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green;"
                  /> -->
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3"
                  />
                  <Button
                    @click="search()
                    cou = true"
                    :label="$t('searchBtn')"
                    class="p-button-info p-mr-2"
                  />
                </div>
              </div>
            </div>

            </div>
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <Dialog  :modal="true"
      header="ค้นหาข้อมูลพื้นที่เกิดเหตุ"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{'overflow-y': 'scroll'}"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue" :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-6">
        <div class="card p-fluid p-mt-2">
          <DataTable
            ref="dt"
            :value="table"
            :scrollable="true"
      scrollHeight="500px"
            :paginator="true"
            :rows="10"
            :rowHover="true"
            :loading="loading" 
            class="p-datatable-sm p-datatable-gridlines"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          <template #header>
          <div class="p-grid p-col " style="padding: 7px 0px 7px 0px;">

            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              
              <!--Doe: excel 1/4  -->
              <Button
                    :label="$t('exportBtn')"
                    class="p-button-info "
                    style="background-color: green;"
                    @click="ExportToExcel('xlsx')"
                  />
              <!--Doe: excel 1/4 จบ -->

            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="(cou == false)">
                <i class="pi pi-search" />
                <InputText
                v-model="filter"
                :loading = false
                  :placeholder="$t('searchHeader')"
                />
              </span>
              <span class="p-input-icon-left" v-else>
                <i class="pi pi-search" />
                <InputText
                v-model="filter"
                @input="searchTable()"
                :loading = false
                  :placeholder="$t('searchHeader')"
                />
              </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
            <template #empty>{{ $t("TableEmpty") }}</template>
            <ColumnGroup type="header">
              <Row>
                <Column :header="$t('local_event')" :rowspan="3" headerStyle="width: 15rem;border: 1px solid #bfbfbf;"/>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column :header="headers.toString()" :colspan="6" :headerStyle="centerStyle"/>
                </div>
              </Row>

              <Row>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column header="เหตุการณ์" :rowspan="2" :field="'event'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="ผู้ประสบภัย" :colspan="5" :field="'victim'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                </div>
              </Row>

              <Row>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column header="บาดเจ็บ" :field="'gs-99hurt'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="เสียชีวิต" :field="'gs-99die'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="สูญหาย" :field="'gs-99lost'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 1/2 -->
                  <Column
                    header="อื่นๆ"
                    :field="'gs-99other' + headerYear.indexOf(headers)"
                    :headerStyle="centerStyle"
                  />
                  <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 1/2 จบ-->
                  <Column header="รวม" :field="'total'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                </div>
              </Row>
            </ColumnGroup>

            <Column field="tambon_name" headerStyle="width: 15rem">
              <template #body="dataTable"> {{ dataTable.data.tambon_name }} </template>
            </Column>

            <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
              <Column :field="'event'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">                
                  <div v-for="years in year" :key="years.id">
                    <div v-if="(years.id == Number(`${headers}`)-543)">
                      <div v-for="event in dataTable.data.event" :key="JSON.stringify(event)">
                        <div v-if="event.to_char == `${years.id}`">
                          {{event.count}}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            
              <Column :field="'gs-99hurt'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99hurt'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>

              <Column :field="'gs-99die'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99die'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
      
              <Column :field="'gs-99lost'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99lost'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
              
              <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 2/2 -->
              <Column
                :field="'gs-99other' + headerYear.indexOf(headers)"
                headerStyle="width: 15rem"
              >
                <template #body="dataTable">
                  <div
                    v-for="victim in dataTable.data.victim"
                    :key="JSON.stringify(victim)"
                  >
                    <div v-if="victim.status_id == 'gs-99other'">
                      <div v-for="years in year" :key="years.id">
                        <div v-if="years.id == Number(`${headers}`) - 543">
                          <div v-if="victim.to_char == `${years.id}`">
                            {{ victim.count }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 2/2 จบ-->

              <Column :field="'total'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'total'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
            </div>
          </DataTable>
        </div>
      </div>

      <div class="p-col-12 p-lg-6">
        <div class="card p-mt-2">
          <div class="chartAreaWrapper">
          <h5 class="centerText">
            {{ $t("TopicGraphReportVictim_byLocal_year") }}
          </h5>
          <span class="centerText">
            {{labelGraph}}</span
          >
          <Chart type="bar" :data="barData"  class="walking-speed-chart"/>
        </div>
      </div>
      </div>
    </div>
     <!--Doe: excel 2/4  -->
     <table id="tbl_V_LY"  >
      
      <DataTable
            ref="dt"
            :value="table"
            :scrollable="true"
      scrollHeight="500px"
            :paginator="true"
            :rows="10"
            :rowHover="true"
            :loading="loading" 
            class="p-datatable-sm p-datatable-gridlines"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 20, 50]"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          
            <ColumnGroup type="header">
              <Row>
                <Column :header="$t('local_event')" :rowspan="3" headerStyle="width: 15rem;border: 1px solid #bfbfbf;"/>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column :header="headers.toString()" :colspan="6" :headerStyle="centerStyle"/>
                </div>
              </Row>

              <Row>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column header="เหตุการณ์" :rowspan="2" :field="'event'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="ผู้ประสบภัย" :colspan="5" :field="'victim'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                </div>
              </Row>

              <Row>
                <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
                  <Column header="บาดเจ็บ" :field="'gs-99hurt'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="เสียชีวิต" :field="'gs-99die'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <Column header="สูญหาย" :field="'gs-99lost'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                  <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 1/2 -->
                  <Column
                    header="อื่นๆ"
                    :field="'gs-99other' + headerYear.indexOf(headers)"
                    :headerStyle="centerStyle"
                  />
                  <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 1/2 จบ-->
                  <Column header="รวม" :field="'total'+headerYear.indexOf(headers)" :headerStyle="centerStyle" />
                </div>
              </Row>
            </ColumnGroup>

            <Column field="tambon_name" headerStyle="width: 15rem">
              <template #body="dataTable"> {{ dataTable.data.tambon_name }} </template>
            </Column>

            <div v-for="headers in headerYear" :key="headerYear.indexOf(headers)">
              <Column :field="'event'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">                
                  <div v-for="years in year" :key="years.id">
                    <div v-if="(years.id == Number(`${headers}`)-543)">
                      <div v-for="event in dataTable.data.event" :key="JSON.stringify(event)">
                        <div v-if="event.to_char == `${years.id}`">
                          {{event.count}}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            
              <Column :field="'gs-99hurt'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99hurt'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>

              <Column :field="'gs-99die'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99die'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
      
              <Column :field="'gs-99lost'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'gs-99lost'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
              
              <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 2/2 -->
              <Column
                :field="'gs-99other' + headerYear.indexOf(headers)"
                headerStyle="width: 15rem"
              >
                <template #body="dataTable">
                  <div
                    v-for="victim in dataTable.data.victim"
                    :key="JSON.stringify(victim)"
                  >
                    <div v-if="victim.status_id == 'gs-99other'">
                      <div v-for="years in year" :key="years.id">
                        <div v-if="years.id == Number(`${headers}`) - 543">
                          <div v-if="victim.to_char == `${years.id}`">
                            {{ victim.count }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
              <!-- เพิ่ม คอลัมน์ตาราง อื่นๆ 2/2 จบ-->

              <Column :field="'total'+headerYear.indexOf(headers)" headerStyle="width: 15rem">
                <template #body="dataTable">
                    <div v-for="victim in dataTable.data.victim" :key="JSON.stringify(victim)">
                      <div v-if="victim.status_id == 'total'">
                        <div v-for="years in year" :key="years.id">
                          <div v-if="(years.id == Number(`${headers}`)-543)">
                            <div v-if="victim.to_char == `${years.id}`">
                              {{victim.count}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </template>
              </Column>
            </div>
          </DataTable>
      
    </table>
    <!--Doe: excel 2/4 จบ -->
    <Dialog  :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import responseAreaTable from "../ResponseAreaTable";
// เพิ่ม pdf กับ font
import { jsPDF } from "jspdf";
import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import * as XLSX from 'xlsx'
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"
   
export default {
  name: "report-victim-location-graph-year",
  components: {
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      dropdownClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ

      responseArea_table: [],
      selectedResponseAreaData: null,
      table: [],
      filters: {},
      barData: [],

      disasterTypeOptions: [],
      disasterTypeSelected: null,
      showResponseArea: false,
      displayConfirmation: false,

      month: this.$month,
      year: [],

      selectedStartYear: null,
      selectedEndYear: null,
      headerYear: [],

      error_table: false,
      labelGraph: '',
      centerStyle: 'border: 1px solid #bfbfbf;text-align:center',
      parentmessage_area: null,

      range_arr: [],
      label:[],
      loading: false,
      // Doe : PDF 3/5
      H:[],
      cop:[],
      c:[],
      col:{},
      head_ex:[],

      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"พื้นที่เกิดเหตุ",
          textShow:"",
        },
        {
          DataName:"ปีเริ่มต้น",
          textShow:"",
        },
        {
          DataName:"ปีสิ้นสุด",
          textShow:"",
        },
        {
          DataName:"ประเภทสาธารณภัย",
          textShow:"",
        },
      ],
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.c == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});
            let dateObj = new Date();
            const result = dateObj.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
            let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`
             
            const doc = new jsPDF('p', 'pt');
            doc.addFileToVFS("m.ttf", font);
                  doc.addFont("m.ttf","m","normal");
                  doc.setFont("m");
   
              doc.autoTable({
                margin: { left: 15 ,right:15 }, 
                styles: {

                          font:'m',
                                       
                        },
                        headStyles:{
                          
                          fontSize: 8,
                          fontStyle: 'bolder',
                          minCellWidth: 25,
                          halign: 'center',
                          valign: 'middle'
                        },
                        bodyStyles:{
                          fontSize: 6,
                          
                        },
                        columnStyles: {
                                        
                        },

                head: this.head,
                columns:this.cop,
                body :this.c,
                theme:'grid',

                  didParseCell:  (HookData) =>{
                  
                    if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined ) {
                      
                        HookData.cell.text = '-';
                    } 
                                       
                  },
                  didDrawPage: () => {
                  doc.setFontSize(13);
                  doc.text("ข้อมูล ณ วันที่ "+result,  570, 34, null, null, "right")
                }
              });

              var pageCount = doc.internal.getNumberOfPages()
              // console.log("pageCount",pageCount)
              for (let index = 0; index < pageCount; index++) {
                doc.setPage(index)
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                doc.text("หน้า "+pageCurrent + " จาก " +pageCount,575,815, null, null, "right")
              }

            // }
              doc.save('ตารางกราฟตามพื้นที่เกิดเหตุ(รายปี)(แนวตั้ง)'+ time +'.pdf');
            }
        },
        
            
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.c == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
            let dateObj = new Date();
            const result = dateObj.toLocaleDateString('th-TH', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })
            let time = `${dateObj.getDate()}-${dateObj.getMonth()+1}-${dateObj.getFullYear()+543}`
             
            const doc = new jsPDF('l', 'pt');
            doc.addFileToVFS("m.ttf", font);
                  doc.addFont("m.ttf","m","normal");
                  doc.setFont("m");

            
              doc.autoTable({
                margin: { left: 15 ,right:15 }, 
                styles: {

                          font:'m',
                                       
                        },
                        headStyles:{
                          
                          fontSize: 8,
                          fontStyle: 'bolder',
                          minCellWidth: 25,
                          halign: 'center',
                          valign: 'middle'

                        },
                        bodyStyles:{
                          fontSize: 6,
                          
                        },
                        columnStyles: {
                          disaster_type:{CellWidth:10},                
                        },

                head: this.head,
                // head:head,
                 columns:this.cop,
                // columns:cooo,
                body :this.c,
                theme:'grid',

                  didParseCell:  (HookData) =>{
                  
                    if (HookData.cell.text[0]== '' || HookData.cell.text[0]== null ||  HookData.cell.text[0]== 'null' || HookData.cell.text[0]== undefined ) {
                      
                        HookData.cell.text = '-';
                    } 
                                       
                  },
                  didDrawPage: () => {
                  doc.setFontSize(13);
                  doc.text("ข้อมูล ณ วันที่ "+result,  802, 34, null, null, "right")
                }
              });

              var pageCount = doc.internal.getNumberOfPages()
              // console.log("pageCount",pageCount)
              for (let index = 0; index < pageCount; index++) {
                doc.setPage(index)
                doc.setFontSize(13);
                let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber
                doc.text("หน้า "+pageCurrent + " จาก " +pageCount,802,570,null, null, "right")
              }

            // }
              doc.save('ตารางกราฟตามพื้นที่เกิดเหตุ(รายปี)(แนวนอน)'+ time +'.pdf');   
            }
            }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },

  async created() {
    await this.axios
          .post(`${this.$url_service}/initial/option`, {
            body: { group: "dg-02" },
          })
          .then((response) => {
            this.disasterTypeOptions = response.data.data
          });
    this.table = [];

    var current_year = new Date().getFullYear();
    this.selectedStartYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    this.selectedEndYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    for (let i = 0; i < 12; i++) {
      this.year.push({ id: `${current_year}`, name: `${current_year + 543}` });
      current_year--;
    }
    this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)
  },

  watch: {
    showResponseArea(val){
      if(val == true){
        if(this.responseArea_table.length > 0){
          this.parentmessage_area = this.responseArea_table
        }else{
          this.parentmessage_area = []
        }
      }
    },
    responseArea_table(val) {
      if (val.length > 0) {
        this.error_table = false;
      }
    },

    disasterTypeOptions(val) {
      if (val.length > 0) {
        this.disasterTypeSelected = {
          system_id: this.disasterTypeOptions[0].system_id,
          system_name: this.disasterTypeOptions[0].system_name,
        };
      }
    },

    table(val){
			if(val.length != 0){
        this.loading = false
				var letters = '0123456789ABCDEF';
				var color = '#';
				var dataset = []
        var result = []
        
				for(let i=0; i<val.length; i++){
          if(val[i].event == '0'){
            result.push(val[i].event)
          }else{
            for(let j=0; j<val[i].victim.length; j++){
              if(val[i].victim[j].status_id == 'total'){
                val[i].victim[j].location_id = `${val[i].tambon_id}`
                val[i].victim[j].location_name = `${val[i].tambon_name}`
                result.push(val[i].victim[j])
              } 
            }		
          }				
        }
        // console.log("result",result)
        // Doe : PDF 4/5
        this.c=[]
            for (let index = 0; index < this.table.length; index++) {
              const name = this.table[index].tambon_name;
              this.c.push({tambon_name:`${name}`}) 
            }
         
            // console.log("this.table ",this.table)
            for (let index = 0; index < this.table.length; index++) {
              const element = this.table[index];
              let c2 =this.c[index]

              for (let index = 0; index < element.event.length; index++) {
                const count = element.event[index].count;
                const to_char = element.event[index].to_char;

                c2[`${to_char}`]=count  
                
              }
              if(element.victim){

              
              for (let index = 0; index < element.victim.length; index++) {
                
                const victim= element.victim[index]
                

                if(victim.status_id == 'gs-99hurt'){
                  
                 
                  c2[`${victim.to_char}EC_count`] = victim.count
                  
                }
                if(victim.status_id == 'gs-99die'){
                  // console.log("ตาย ",victim.count)
                  c2[`${victim.to_char}VD_count`] = victim.count
                }
                if(victim.status_id == 'gs-99lost'){
                  // console.log("หาย ",victim.count)
                  c2[`${victim.to_char}VL_count`] = victim.count
                }
                if(victim.status_id == 'gs-99other'){
                  // console.log("อื่นๆ ",victim.count)
                  c2[`${victim.to_char}VO_count`] = victim.count
                }
                if(victim.status_id == 'total'){
                  // console.log("รวม ",victim.count)
                  c2[`${victim.to_char}VT_count`] = victim.count
                }else{
                  // 
                }
              }
            }
            }
      
            // console.log("this.c ",this.c)
          // Doe : PDF 4/5 end
				var all_amount = []
				for(let t=0; t<val.length; t++){
					for(let i=0; i<this.range_arr.length;i++){
						for(let j=0; j<result.length;j++){
							if(this.range_arr[i] == result[j].to_char){
								if(val[t].tambon_id == result[j].location_id){
									all_amount.push(`${result[j].count}`)
								}else{
									all_amount.push('0')
								}
							}else{
								all_amount.push('0')
							}
						}
						
					}
        }
        
				var number = []
				var index;
				var all = []
				for(let j=0; j<val.length; j++){
					for(let i=1; i<=this.range_arr.length; i++){
						index = i*result.length
						var temp = 0;
						for(let k=(index-result.length); k<index; k++){
							temp += Number(all_amount[k])
						}
						number.push(temp)
					}
					all_amount = all_amount.slice(index)
					all.push({'id':number})
					number = []
        }

				for(let j=0; j<val.length;j++){
					for (let k = 0; k < 6; k++) {
						color += letters[Math.floor(Math.random() * 16)];
					}
					dataset.push({label:`${val[j].tambon_name}`,backgroundColor:`${color}`,borderColor:`${color}`,data:all[j].id})
					color = '#'
				}
		
				this.barData = {
					labels: this.label,
					datasets: dataset 
				};
			}
		}
  },

  mounted() {},
  methods: {
            exportCSV() {
      debugger
      this.$refs.dt.exportCSV();
    },
    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    search() {
      this.filter='';
      this.cloneTable=[];
      this.range_arr = [];
      this.table = [];
      this.headerYear = [];
      this.label = [];
      this.barData = [];
      this.H=[];
      this.c=[];
      this.cop=[];
      this.col={};
      this.labelGraph = ""
      if(this.responseArea_table.length == 0){
				this.error_table = true
			}else {
        if (this.selectedStartYear.id <= this.selectedEndYear.id) {
          this.setHeader();
        }
      }
    },

    async setHeader() {
      this.filter='';
      this.cloneTable=[];
      this.range_arr = []
			this.table = []	
			this.headerYear = []
			this.label = []
      this.labelGraph = `รายปี ${this.selectedStartYear.name} ถึง ${this.selectedEndYear.name} | ประเภทสาธารณภัย : ${this.disasterTypeSelected.system_name}`
			if(this.selectedStartYear.id == this.selectedEndYear.id){
        this.headerYear.push([`${this.selectedStartYear.name}`])
        this.label.push(`${this.selectedStartYear.name}`)
        this.range_arr.push(`${this.selectedStartYear.id}`)
			}else{
				var startY = Number(this.selectedStartYear.id)
				var endY = Number(this.selectedEndYear.id)
				var diff_year = (endY - startY)-1
				if(diff_year == 0){
					this.headerYear.push([`${this.selectedStartYear.name}`])
          this.headerYear.push([`${this.selectedEndYear.name}`])
          this.label.push(`${this.selectedStartYear.name}`)
          this.label.push(`${this.selectedEndYear.name}`)
          this.range_arr.push(`${this.selectedStartYear.id}`)
          this.range_arr.push(`${this.selectedEndYear.id}`)
				}else{
					var year_range = [this.selectedStartYear.id,this.selectedEndYear.id]
					for(let i=0; i<diff_year; i++){
						var check = `${Number(year_range[i]) + 1}`
						year_range.splice(i+1,0,check)
					}
					// console.log(year_range)
          this.headerYear.push([`${this.selectedStartYear.name}`])
          this.label.push(`${this.selectedStartYear.name}`)
          this.range_arr.push(`${this.selectedStartYear.id}`)
          
					for(let j=1; j<(year_range.length - 1); j++){
            this.headerYear.push([`${Number(year_range[j])+543}`])
            this.label.push(`${Number(year_range[j])+543}`)
            this.range_arr.push(`${Number(year_range[j])}`) 
					}
          this.headerYear.push([`${this.selectedEndYear.name}`])
          this.label.push(`${this.selectedEndYear.name}`)
          this.range_arr.push(`${this.selectedEndYear.id}`)
				}
      }

      this.loading = true
      await this.axios
				.post(`${this.$url_service}/get/report`, { 
					body: { 
            topic: "get-report-victim",
            subtopic: "get-report-victim-location-graph-year",
						start_year: this.selectedStartYear.id,
						end_year: this.selectedEndYear.id,
            disaster: this.disasterTypeSelected.system_id,
            location: this.responseArea_table,
            event: '', status: '' 
					} })
        .then((response) => {
          // (console.log(response.data.data)),
          (this.table = response.data.data)
          // Doe : PDF 5/5
          // Doe ค้นหา  4/6 
          this.cloneTable = response.data.data
          // Doe ค้นหา  4/6

          this.H=[{content:"ประเภทสาธารณภัย",rowSpan:3,styles: {fillColor: [19, 141, 117 ] }}]
          
            for (let index = 0; index < this.headerYear.length; index++) {
              const element = this.headerYear[index].toString();
              
              this.H.push({content:element,colSpan:6,styles: {fillColor: [19, 141, 117 ]} })

            }
          
            
          this.H2 =[]
            
            for (let index = 0; index < this.headerYear.length; index++) {  
              this.H2.push({content:"เหตุการณ์",rowSpan:2,styles: {fillColor: [22, 160, 133]}},
                           {content:"ผู้ประสบภัย",colSpan: 5,styles: {fillColor: [22, 160, 133]}})
            }
          this.H3 =[]
            
            for (let index = 0; index < this.headerYear.length; index++) {  
              this.H3.push({content:"บาดเจ็บ",styles: {fillColor: [69, 179, 157]}},
                           {content:"เสียชีวิต",styles: {fillColor: [69, 179, 157]}},
                           {content:"สูญหาย",styles: {fillColor: [69, 179, 157]}},
                           {content:"อื่นๆ",styles: {fillColor: [69, 179, 157]}},
                           {content:"รวม",styles: {fillColor: [69, 179, 157]}},
                          )
            }
              
            // console.log("HHHHH ",this.H)
            // console.log("H2 ",this.H2)
            // console.log("H3 ",this.H3)

            this.head=[]
            this.head=[this.H].concat([this.H2],[this.H3])
           
            // console.log("this.head ",this.head)


            // คอลัมน์
            this.cop =[{ dataKey:"tambon_name"}]
               
            for (let index1 = 0; index1 < this.headerYear.length; index1++) {

              for (let index = 0; index < this.year.length; index++) {
                let year = this.year[index].id
                
                if (this.year[index].id == Number(`${this.headerYear[index1]}`)-543) {
                  // console.log("year ",year)
                  
                  this.cop.push({dataKey:`${year}`})
                        for (let index = 0; index < 1; index++) {
                          this.cop.push({dataKey:`${year}EC_count`})
                          this.cop.push({dataKey:`${year}VD_count`})
                          this.cop.push({dataKey:`${year}VL_count`})
                          this.cop.push({dataKey:`${year}VO_count`})
                          this.cop.push({dataKey:`${year}VT_count`})
                          
                        } 
                       
                }
                
              }
              
            }

            this.setSearchText_Footer()

        });
        this.loading = false

    },
    setSearchText_Footer(){
          this.text_Footer=false;

          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.responseArea_table.length !== 0 ||
              this.selectedStartYear !== null ||
              this.selectedEndYear !== null ||
              this.disasterTypeSelected !== null   ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "พื้นที่เกิดเหตุ" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "ปีเริ่มต้น" && this.selectedStartYear !== null ){
                  element.textShow = this.selectedStartYear.name
                }
                if(element.DataName === "ปีสิ้นสุด" && this.selectedEndYear !== null){
                  element.textShow = this.selectedEndYear.name
                }
                if(element.DataName === "ประเภทสาธารณภัย" && this.disasterTypeSelected !== null){
                  element.textShow = this.disasterTypeSelected.system_name
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text_Double(data1,data2){
      let text = []
      text += "เดือน : " + data1.name + " ปี : " + data2.name+ ","
      return  text.slice(0, -1)
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {
          return item.tambon_name.includes(this.filter)

      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    confirmDelete() {
      this.responseArea_table = this.responseArea_table.filter(
        (val) => val !== this.responseAreaDelete
      );
      this.displayConfirmation = false;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.dropdownClearFilerValue += 1;
      this.table = [];
      this.responseArea_table = [];
      this.disasterTypeSelected = {
        system_id: this.disasterTypeOptions[0].system_id,
        system_name: this.disasterTypeOptions[0].system_name,
      };
      this.error_table = false;
      this.temp = "";
      this.barData = []
      this.H=[];
      this.c=[];
      this.cop=[];
      this.col={};
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
       // Doe ค้นหา
       this.filter='';
      this.cloneTable=[];
    },
    /* Doe: excel 3/4 */
    ExportToExcel(type, fn, dl) {
      if(this.c==""){
        //
      }else{
            var elt = document.getElementById('tbl_V_LY');
            var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
            return dl ?
                XLSX.write(wb, { bookType: type, bookSST: true, type: 'base64' }) :
                XLSX.writeFile(wb, fn || (`ตารางกราฟตามพื้นที่เกิดเหตุ(รายปี)-${this.date}.` + (type || 'xlsx')));
        }
      },
    /* Doe: excel 3/4 จบ*/
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
@media screen and (max-width: 430px) {
  #H_DGM{
    margin: 0 !important;
  }
  #DGM{
    margin-left: 0 !important;
  }
  #DGM_M{
    margin: 14px 0 0 0 !important;
  }
  #DGM_M_S{
    padding: 7px 0;
  }
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
  /* .multiselect-custom {
    width: 13rem !important; 
  } */
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
/* Doe: excel 4/4 */
#tbl_V_LY{
  display: none;
}
/* Doe: excel 4/4 จบ */
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
  min-width: 15rem;
}

.multiselect-custom {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>


<style>
  /* ! ส่วนกราฟ */
  .chartAreaWrapper {
         width: 100%;
         overflow-x: scroll;
    }
  
  .walking-speed-chart{
         /* margin-top: 20px; */
         height: 80%;
         width: 880px;
    }
  
  
    @media screen and (max-width: 1540px) {
      .walking-speed-chart{
         height: 80%;
         width: 690px;
    }
  
  }
  
  /* ! จบส่วนกราฟ */
  </style>